export const MSEnum = {
  AppCode: 'TaskGo',

  /**
   * Trạng thái lọc grid chuyển đổi dữ liệu
   */
  ConvertState: {
    All: 1,
    Converted: 2,
    NotConvert: 3,
  },

  /**
   * Trạng thái làm việc của cá nhân
   * tương đương enum bên QLCBgetEnumSource
   */
  EmployeeStatus: {
    Working: 0,
    ForeignWork: 9,
    LeaveJob: 1,
    Retiring: 2,
    OutOfSystem: 6,
  },

  //Loại cán bộ
  EmployeeType: {
    // Cán bộ
    Executive: 0,

    // Công chức
    PublicServant: 1,

    // Viên chức
    Official: 2,

    // Lao động hợp đồng
    ContractLabour: 3,

    // Người hoạt động không chuyên trách xã
    HDKCTX: 4,

    // Người hoạt động không chuyên trách thôn
    HDKCTT: 5,

    // Lãnh đạo chuyên trách các hội đặc thù
    LDCTCHDT: 7,

    // Loại cán bộ khác
    Other: 6,
  },

  OrganizationUnitLevel: {
    // Đơn vị chủ quản cao nhất trong mô hình triển khai
    Hight: 1,
    // Đơn vị chủ quản cấp dưới
    Medium: 2,
    //Đơn vị trực thuộc
    Low: 3
  },

  /**
     * Enum fire base
     */
  ActionTypeFireBase: {
    View: 'View',
    Print: 'Print',
    Insert: 'Insert',
    Update: 'Update',
    Delete: 'Delete'
  },

  AppNameFireBase: {
    AppCode: 'TaskGo2'
  },

  /**
     * Enum cấu hình style của ô check box multi-grid
     */
  ShortKeyToolTip: {
    Add: "F9",
    Close: "ESC", //Đóng
    Save: "Ctrl + S", //Cất
    SaveAndAdd: "Ctrl + Shift + S", //Cất và thêm
    Help: "F1", //Giúp
    Print: "Ctrl + P", //IN
    Maximum: "Ctrl + Space", //phóng to thu nhỏ form
    QuickSelect: "F3", //chọn nhanh
  },

  /**
     * Vai trò người dùng
     */
  UserRoleType: {
    /**
         * Trưởng
         */
    Chief: 1,
    /**
         * Phó
         */
    Deputy: 2,
    /**
         * Nhân viên
         */
    Employee: 3,
  },

  /**
     * http status code
     */
  HttpStatusCodes: {
    /**
         * Lỗi business VD: validate
         */
    BusinessError: 550,

    /**
         * Lỗi server
         */
    ServerError: 500,

    /**
         * Không tìm thấy bản ghi
         */
    NotFound: 404
  },

  /**
     * Mã lỗi gửi từ server
     */
  ServerErrorCodes: {
    Validate: 'VALIDATE',
  },

  /**
     * Mã lỗi validate
     */
  ValidateCodes: {
    /**
         * Lỗi edit version
         */
    EditVersion: 'EditVersion',

    /**
         * Ko có quyền xem công việc
         */
    NotAllowViewTask: 'NotAllowViewTask',
  },

  /**
     * Trạng thái của form
     */
  FormState: {
    /**
         * Mode View
         */
    View: 0,

    /**
         * Thêm
         */
    Add: 1,

    /**
         * Sửa
         */
    Edit: 2,

    /**
         * Nhân bản
         */
    Duplicate: 4,

    /**
         * Thêm nhanh
         */
    QuickAdd: 5,
  },

  /**
   * Trạng thái người dùng
   */
  UserStatus: {
    // Chờ xác nhận
    Waiting: 1,
    // Đang hoạt động
    Active: 2,
    // Ngừng hoạt động
    InActive: 3,
    // Đã xóa
    Deleted: 4
  },

  /**
   * Enum vai trò của hệ thống
   */
  DictionaryKey: {
    //Quản trị hệ thống
    AdminSystem: 1,
    //Thực hiện công việc
    PerformETask: 2
  },

  /**
   * Trạng thái của model
   */
  ModelState: {
    None: 0,
    Insert: 1,
    Update: 2,
    Delete: 3,
    Duplicate: 4,
  },

  /**
     * Option lựa chọn share file cho công việc con
     */
  ShareOption: {
    No: 1, // Không share
    All: 2, // Share cho tất cả
    Select: 3 // Share cho công việc con nhất định
  },

  StorageFileType: {
    /// File tạm
    Temp: 0,
    /// Các file dữ liệu mang đi
    SystemData: 1,
    /// Script sql của đăng ký dữ liệu
    Register: 2,
    /// File đính kèm
    Attachment: 3,
    /// Script nâng cấp dữ liệu khách hàng
    /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
    /// 1.0.0.1, 1.0.0.2....
    SqlUpgradeTenant: 4,
    /// Script nâng cấp dữ liệu system
    /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
    /// 1.0.0.1, 1.0.0.2....
    SqlUpgradeSystem: 5,
    /// Script nâng cấp dữ liệu manage
    /// Trong này sẽ chia các thư mục nhỏ theo từng bản build
    /// 1.0.0.1, 1.0.0.2....
    SqlUpgradeManage: 6,
    /// file script nâng cấp db queue
    SqlUpgradeQueue: 7,
    /// Commandtext
    SqlCommand: 8,
    /**
   * File lấy bộ thông tin truyền thông
   * NTDIEM 07/09/2023
   */
    GovementAttachment: 20,
  },

  // Các kiểu value của combobox date time
  DateTimeValueType: {
    ThisWeek: 1,
    LastWeek: 2,
    ThisMonth: 3,
    LastMonth: 4,
    ThisYear: 5,
    Custom: 999,
    NoLimit: 7,
    All: 8,
    ThisQuarter: 9,
    LastQuarter: 10,
    LastYear: 11
  },

  // Các field để filter tương ứng với datafield
  DataFieldFilter: {
    PeopleInvolved: 't.PeopleInvolvedIDs',
    Status: 't.CustomStatus',
    Priority: "t.Priority -> '$.PriorityName'",
    TaskType: "t.TaskType -> '$.TaskTypeName'",
    Executor: 't.ExecutorID',
    Combination: 't.CombinationIDs',
    Assigner: 't.AssignerID',
    Supervisor: 't.Supervisor',
    EndDate: 't.EndDate',
    SendTaskDate: 't.SendTaskDate',
    StartDate: 't.StartDate',
    DocumentDate: 't.DocumentDate',
    DocumentCode: 't.DocumentCode',
    DocumentSigner: 't.DocumentSigner',
    RatingStar: 't.RatingStar',
    DateRange: 't.EndDate',
    StatusApprovalMission: 't.StatusApprovalMission'
  },

  // Các field để sort tương ứng với datafield
  SortDataField: {
    Status: 'tt.CustomStatus',
    SendTaskDate: 'tt.SendTaskDate',

    /**
     * 1 ở đầy là trạng thái nháp
     * Lúc lưu nháp thì người chủ trì đc lưu dưới dạng mảng
     */
    Executor: `IF(tt.Status = 1, tt.Executor->>'$[0].FullName', tt.Executor->>'$.FullName')`
  },

  SortDataEnum: {
    Status: 1, // Tình trạng công việc
    SendTaskDate: 2, // Ngày giao việc
    Executor: 3 // Người, đơn vị
  },

  SortType: {
    /**
     * Giảm dần
     * */
    DESC: 1,
    /**
     * Tăng dần
     */
    ASC: 2
  },

  SubsystemCode: {
    // tab tổng quan
    DashBoard: 'DashBoard',
    // tab báo cáo
    Report: 'Report',
    // Công việc
    TaskList: 'TaskList',
    // Thiết lập cá nhân: Ủy quyền, Nhóm giao việc
    ConfigPersonal: 'ConfigPersonal',
    // Thiết lập chung: Chức vụ, Loại việc, Mức độ ưu tiên, Thời gian được phép quá hạn, Đánh giá công việc
    ConfigGeneral: 'ConfigGeneral',
    // Danh sách người dùng
    UserList: 'UserList',
    // Người dùng - Vai trò
    UserRole: 'UserRole',
    // Danh sách phòng ban
    DepartmentList: 'DepartmentList',
  },

  reminderTime: {
    minute: 1,
    hour: 2,
    day: 3,
    option: 4
  },

  // Đánh giá công việc
  RatingStar: {
    ZeroStar: 0,
    OneStar: 1,
    TwoStar: 2,
    ThreeStar: 3,
    FourStar: 4,
    FiveStar: 5,
    All: 6
  },

  /**
   * Vai trò mặc định mặc định mang đi
   * NTTHANH1 13/04/2023
   */
  RoleCode: {
    AdminSystem: "AdminSystem",
    PerformETask: "PerformETask"
  },

  // Phương thức xác  thực
  SendCodeMethod: {
    Email: 1,
    PhoneNumber: 2,
    App: 3
  },

  //Điều phối bàn giao công việc
  HandoverUserType: {
    FromUser: 1,//người Cần bàn giao
    ToUser: 2,//người Được bàn giao
  },

  /**
   * Loại nhập khẩu
   */
  ImportType: {
    /**
     * Công việc
     */
    Task: 1,

    /**
     * Người dùng
     */
    User: 2,
  },

  /**
  * Trạng thái sắp xếp
  */
  SortStatus: {
    /**
     * Không sort
     */
    none: 0,

    /**
     * Giảm dần
     */
    desc: 1,

    /**
     * Tăng dần
     */
    asc: 2,
  },

  /**
   * Xử lý hồ bị trùng
   */
  HandleDuplicateProfile: {
    Update: 1,
    Skip: 2
  },

  /**
   * Lịch sử thỏa thuận/ cs quyền riêng tư
   */
  AgreementType: {
    TermsOfService: 1, //Lịch sử thỏa thuận
    Privacy: 2, // Cs quyền riêng tư
    Agreements: 3 // thỏa thuận mua hàng
  },

  UpsertMissionErrorCode: {
    None: 0, // Không có lỗi
    Required: 1, // Có lỗi xảy ra
    Unauthorized: 401, // Phiên đăng nhập không hợp lệ
    ServerError: 500, // Server gặp lỗi
    InvalidIP: 2, //IP không hợp lệ
    NotExist: 5, //Nhiệm vụ không tồn tại
    ApprovedMission: 6, //Không thực hiện được do nhiệm vụ đã được duyệt
    NoRight: 7, //Không có quyền cập nhật nhiệm vụ
  },

  MissionType: {
    CQDV: 59, //Cơ quan, đơn vị đề nghị phối hợp
    LDS: 54, // Nhiệm vụ Lãnh đạo Sở giao
    KHAC: 50, // Nhiệm vụ khác
    BTTTT: 39, // Nhiệm vụ do Bộ TTTT giao
    UBND: 38, // Nhiệm vụ UBND tỉnh thành phố giao
    TUTU: 37, // Nhiệm vụ Tỉnh ủy, Thành ủy giao
  },
  //1: Người giao vieejc; 2: Người phụ trách; 3: NGười chủ trì; 4: Người phối hợp; 5: Người liên quan
  SettingNotifyRole: {
    Assigner: 1,
    Supervisor: 2,
    Executor: 3,
    Combination: 4,
    PeopleInvolved: 5
  },

  //Đường dẫn đến từng màn help case theo name của màn hình đang hiển thị
  //TDNGHIA 26/10/2023
  HelpID: {
    dashboardcharts: "theo-doi-tong-quan-tinh-hinh-cong-viec",
    needtodo: "xu-ly-cong-viec-duoc-giao",
    assignedbyme: "theo-doi-giam-sat-cong-viec",
    needtoapprove: "phe-duyet-cong-viec",
    relatedtome: "nguoi-lien-quan",
    generalsetting: "thiet-lap-chung",
    departmentlist: "thiet-lap-danh-sach-phong-ban",
    user: "thiet-lap-nguoi-dung-vai-tro",
    role: "thiet-lap-nguoi-dung-vai-tro",
    userlist: "quan-ly-danh-sach-nguoi-dung",
    authorization: "uy-quyen-cho-nguoi-khac",
    assignmentgroup: "uy-quyen-cho-nguoi-khac",
    handover: "dieu-phoi-ban-giao-cong-viec",
    personalsetting: "uy-quyen-cho-nguoi-khac",
    ImportUser: 'new/knowledge-base/thiet-lap-nguoi-dung-vai-tro/#nhap-khau-thong-tin-nguoi-dung',
    ImportTask: 'knowledge-base/them-moi-cong-viec-2/',
    CustomChart: "new/knowledge-base/theo-doi-tong-quan-tinh-hinh-cong-viec/#iv-tuy-chinh-bieu-do"
  },

  UpdateDeadlineStatus: {
    // Chờ duyệt
    WaitingApproval: 1,
    // Đã duyệt
    Approved: 2,
    //Từu chối
    Rejected: 3,
    //Thu hồi
    Cancel: 4,
  },

  /**
   * Trạng thái đánh giá của khách hàng
   */
  CustomerSurveyState: {
    NotGood: 0, //Chưa hài lòng
    Good: 1, //Hài lòng
    VeryGood: 2, //Tuyệt vời
  },
  /**
   * Các hành động để log tình hình sử dụng lên MCP
   * DTQUOC 23.01.2025
   */
  MCPEvent: {
    Login: 1, // Đăng nhập
    AddTask: 22, // Thêm công việc
    UpdateTask: 23, // Sửa công việc
    DeleteTask: 24, // Xóa công việc
    ChangeTaskStatus: 25, // Thay đổi tiến độ công việc
    AssignTaskToSubordinate: 26, // Giao việc cho đơn vị cấp dưới
    ApproveTaskForSubordinate: 27 // Phê duyệt công việc cho cấp dưới
  },
  MCPEventName: {
    Login: 'Đăng nhập', // Đăng nhập
    AddTask: 'Thêm công việc', // Thêm công việc
    UpdateTask: 'Sửa công việc', // Sửa công việc
    DeleteTask: 'Xóa công việc', // Xóa công việc
    ChangeTaskStatus: 'Thay đổi trạng thái công việc', // Thay đổi tiến độ công việc
    AssignTaskToSubordinate: 'Giao việc cho đơn vị cấp dưới', // Giao việc cho đơn vị cấp dưới
    ApproveTaskForSubordinate: 'Phê duyệt công việc cho đơn vị cấp dưới' // Phê duyệt công việc cho cấp dưới
  }
}

export const theme = {
  light: 'light',
  dark: 'dark'
}